import PlaylistTrack from './PlaylistTrack';
import styles from './PlaylistTracklist.module.scss';

const PlaylistTracklist = ({
  clips,
  currentLiveViewers,
  isExpanded,
  isPlaying,
  selectedClipId,
  switchClip,
  tracklistRef,
}) => (
  <div
    className={`${styles.playlistTracklist} ${isExpanded ? styles.expanded : ''}`}
    ref={tracklistRef}
  >
    {clips.map((clip) => (
      <PlaylistTrack
        key={clip.id}
        clip={clip}
        currentLiveViewers={currentLiveViewers}
        isPlaying={isPlaying}
        isSelected={selectedClipId === clip.id}
        switchClip={switchClip}
      />
    ))}
  </div>
);

export default PlaylistTracklist;
